module.exports = __webpack_public_path__ + "img/Overall spends.5c8b3a7b.svg";